import { Container, Row, Col, Card, Badge, Button } from 'react-bootstrap';
import ImageGallery from 'react-image-gallery';
import { MdDirectionsCar, MdModeOfTravel, MdAvTimer, MdColorLens, MdOutlineMoney, MdPerson, MdShare, MdGpsFixed, MdAcUnit, MdFlashOn, MdPanoramaWideAngle, MdCameraRear, MdCarRepair, MdSettingsInputComponent, MdAirlineSeatReclineExtra, MdEngineering, MdOutlineAirlineSeatReclineNormal, MdOutlineCameraRear, MdLocationOn, MdLocalParking, MdBalcony, MdBuild, MdPool, MdYard, MdSecurity, MdFitnessCenter, MdAir, MdFireplace, MdDeck, MdOutlineWifi, MdOutlineTheaters, MdOutlineLocalLaundryService, MdOutlineWbSunny, MdOutlineVisibility, MdOutlineDoorFront, MdOutlineSmartToy } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { FETCH_PROPERTY_SUCCESS, FETCH_VEHICLE_SUCCESS } from '../../../app/actions/actions';
import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../config/routingUrl';
import { RiEye2Fill } from 'react-icons/ri';
import { Vector_Design, emptyImage } from '../../../utils/dataApi/dataFormApi';
import { FaHorseHead, FaMapLocationDot } from 'react-icons/fa6';
import { FaArrowAltCircleLeft, FaChargingStation, FaMapMarkedAlt, FaSun, FaTachometerAlt } from 'react-icons/fa';
import { IoSpeedometerOutline } from 'react-icons/io5';
import { TbManualGearbox } from 'react-icons/tb';
import { BsCalendar } from "react-icons/bs";
import { SiTurbosquid } from "react-icons/si";
import MapContainerModal from '../../admin/reservations/maps/MapModal';
import ShareComponentModal from '../../admin/reservations/maps/ShareModal';


const PropertyDetails = ({ property }) => {

  const navigate = useNavigate();

  const paramProperty = useParams();

  const dispatch = useDispatch();
  // 🔗 Générer le lien de partage
  const shareUrl = window.location.href;

  // const propertys = useSelector((state) => state.propertys.propertys)

  // useEffect(() => {
  //     console.log(paramVehcile?.id);
  //     const objetTrouve = propertys && [...propertys].length > 0 ? [...propertys].find(objet => objet._id === paramVehcile?.id) : property ;
  //     dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: objetTrouve });
  // }, [paramVehcile]);


  const images = property && property.images && property.images.length > 0 ? property.images.map((image) => ({
    original: image,
    thumbnail: image
  })) : [{
    original: emptyImage,
    thumbnail: emptyImage
  }];


  const [showModal, setShowModal] = useState(false);

  // Exemple de données pour l'élément à afficher
  const elementData = {
    address: "123 Rue de l'Exemple, Alger",
    lat: property?.lat, // Latitude d'exemple
    lng: property?.lng,  // Longitude d'exemple
  };

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const [showModalShare, setShowModalShare] = useState(false);



  const handleShowModalShare = () => setShowModalShare(true);
  const handleCloseModalShare = () => setShowModalShare(false);



  const textStyleElement = {
    
    display: '-webkit-box',
    WebkitLineClamp: 1, // Limite à 3 lignes
    maxWidth: "80px",
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };


  return (
    <section className="container-fluid" style={{ padding: "100px 0px 0px 0px", background: "#F5FDF7" }}>
      <div className="container" style={{ position: "relative", zIndex: 65 }}>
        <div className="pb-5">
          <div>
            <Button className="" onClick={() => { navigate(-1) }} variant="dark" style={{ borderRadius: "20px", padding: "10px 10px 10px 10px" }}>
              <span className="bg-white rounded-lg"><FaArrowAltCircleLeft color={"#42B711"} size={30} /></span>  <span className="px-3"> Retour </span></Button>
          </div>
        </div>
        <div className="row">
          <Col md={6}>
            <div className="" style={{ height: '100%', }}>
              <div>
                {/* Galerie d'images */}
                <ImageGallery
                  items={images}
                  showThumbnails={true}
                  showFullscreenButton={false}

                  showPlayButton={false}
                  renderItem={(item) => (
                    <img
                      src={item.original}
                      alt=""
                      className="img-fluid rounded-lg"
                      style={{
                        height: '350px',
                        width: '100%',
                        objectFit: 'fill',
                        overflow: 'hidden',
                        borderRadius: "15px", // Coins arrondis pour l'image
                      }}
                    />
                  )}
                />
              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className=" rounded-5  m-b40 m-sm-b0">
              <div className="">
                <div>
                  <div className="dlab-post-title">
                    <h3 className="post-title">
                      <Link to="javascript:void(0);" style={{ fontSize: "32px", color: "black" }}>{property?.name || ""}</Link>
                    </h3>
                    {/*<h6 className="sub-title">{property?.type?.name || ""}</h6> */}
                    <div style={{ display: "flex", alignContent: "center" }}>
                      <span style={{ fontWeight: "bold", color: "black", fontSize: "32px" }} className="font-bold"> {property.basePricePerDay || 0} </span>
                      <span style={{ fontWeight: "bold", color: "black", fontSize: "32px" }} className="px-1"> DZD </span>
                      <span style={{ color: "#A6A6A6", fontSize: "20px", textAlign: "end" }} className="px-1 pt-2"> /Jour</span>
                    </div>
                  </div>

                  {/* ✅ Caractéristiques du véhicule */}


                  {// property
                    property?.address && (
                      <div className="row">
                        <div className="col-md-6 p-1">
                          <div style={{ padding: "2px 5px 2px 5px", display: "flex", justifyItems: "center", background: "white" }} className="bg-white my-2 rounded-lg ">
                            {property?.address && (
                              <div
                                className=" bg-white p-1 m-1 d-flex flex-row align-items-center justify-content-start"
                                style={{ width: "100%" }}
                              >
                                <MdLocationOn className="text-dark mb-1" size={30} />
                                <span className="text-start text-dark d-inline-block text-truncate" style={{ maxWidth: "100%" }}>{property?.address || 0}</span>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6 p-1">
                          <div style={{ padding: "2px 5px 2px 5px", display: "flex", justifyItems: "center", background: "white" }} className="bg-white my-2 rounded-lg ">
                            {property?.address && (
                              <div
                                className=" bg-white p-1 m-1 d-flex flex-row align-items-center justify-content-start"
                                style={{ width: "100%", cursor: "pointer" }} onClick={handleShowModal}
                              >
                                <FaMapLocationDot className="mb-1" color={"#42B711"} size={25} />
                                <span className="text-start d-inline-block text-truncate" style={{ maxWidth: "100%", color: "#42B711" }}>Voire carte</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )
                  }
                  {// property
                    (property?.size || property?.yearBuilt) && (
                      <div className="row">
                        <div style={{ padding: "2px 5px 2px 5px", display: "flex", justifyItems: "center", background: "white" }} className="col-md-12 bg-white my-3 my-2 rounded-lg">
                          {property?.size && (
                            <div
                              className=" bg-white p-1 m-1 d-flex flex-column align-items-center justify-content-center"
                              style={{ width: "120px" }}
                            >
                              <IoSpeedometerOutline className="text-dark mb-1" size={25} />
                              <span className="text-center text-dark text-sm">{property?.size || 0}</span>
                            </div>
                          )}

                          {/* Transmission */}
                          {(property?.yearBuilt) && (
                            <div
                              className=" bg-white p-1 m-1 d-flex flex-column align-items-center justify-content-center"
                              style={{ width: "120px" }}
                            >
                              <TbManualGearbox className="text-dark mb-1" size={25} />
                              <span className="text-center text-dark text-sm">
                                {property?.yearBuilt ? "0" : ""}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    )
                  }

                </div>
              </div>
            </div>
          </Col>
          {/*options supplementaires */}
        </div>
      </div>






      <div className="container-fluid " style={{ position: "relative", zIndex: 60, top: -150, background: "linear-gradient(90deg, #43B613, #1D5008)", padding: "100px 10px 100px 10px" }}>
        <div className="container bg-transparent" style={{ position: "relative", zIndex: 70 }}>
          <div className="row">
            <Col md={6}>
              <div className="col-md-6">
                <div>
                  <h4 className="text-white"> Description </h4>

                  <p className="pt-5 text-white">
                    {
                      property?.description || ""
                    }
                  </p>

                </div>
              </div>

            </Col>

            {/* ✅ Section Prix & Réservation */}
            <Col md={6}>
              <div className="m-b40 m-lg-b30">
                {
                  // Vérifie si au moins une option est activée
                  (property?.options?.hasParking ||
                    property?.options?.hasBalcony ||
                    property?.options?.hasElevator ||
                    property?.options?.hasSwimmingPool ||
                    property?.options?.hasGarden ||
                    property?.options?.hasSecurity ||
                    property?.options?.hasGym ||
                    property?.options?.hasAirConditioning ||
                    property?.options?.hasFireplace ||
                    property?.options?.hasTerrace ||
                    property?.options?.hasInternet ||
                    property?.options?.hasCinemaRoom ||
                    property?.options?.hasLaundryRoom ||
                    property?.options?.hasSolarPanels ||
                    property?.options?.hasVideoSurveillance ||
                    property?.options?.hasElectricGate ||
                    property?.options?.hasSmartHome) && (
                    <div
                      style={{
                        padding: "5px",
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center", // Centre les éléments verticalement
                      }}
                      className="my-3 rounded-lg"
                    >
                      {/* Parking */}
                      {property?.options?.hasParking && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdLocalParking className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate"  style={textStyleElement} >Parking</span>
                        </div>
                      )}

                      {/* Balcon */}
                      {property?.options?.hasBalcony && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdBalcony className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Balcon</span>
                        </div>
                      )}

                      {/* Ascenseur */}
                      {property?.options?.hasElevator && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdBuild className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Ascenseur</span>
                        </div>
                      )}

                      {/* Piscine */}
                      {property?.options?.hasSwimmingPool && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdPool className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Piscine</span>
                        </div>
                      )}

                      {/* Jardin */}
                      {property?.options?.hasGarden && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdYard className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Jardin</span>
                        </div>
                      )}

                      {/* Sécurité 24h/24 */}
                      {property?.options?.hasSecurity && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdSecurity className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Sécurité 24h/24</span>
                        </div>
                      )}

                      {/* Salle de sport */}
                      {property?.options?.hasGym && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdFitnessCenter className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Salle de sport</span>
                        </div>
                      )}

                      {/* Climatisation */}
                      {property?.options?.hasAirConditioning && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdAir className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Climatisation</span>
                        </div>
                      )}

                      {/* Cheminée */}
                      {property?.options?.hasFireplace && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdFireplace className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Cheminée</span>
                        </div>
                      )}

                      {/* Terrasse */}
                      {property?.options?.hasTerrace && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdDeck className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Terrasse</span>
                        </div>
                      )}

                      {/* Connexion Internet */}
                      {property?.options?.hasInternet && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdOutlineWifi className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Connexion Internet</span>
                        </div>
                      )}

                      {/* Salle de cinéma */}
                      {property?.options?.hasCinemaRoom && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdOutlineTheaters className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Salle de cinéma</span>
                        </div>
                      )}

                      {/* Buanderie */}
                      {property?.options?.hasLaundryRoom && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdOutlineLocalLaundryService className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Buanderie</span>
                        </div>
                      )}

                      {/* Panneaux solaires */}
                      {property?.options?.hasSolarPanels && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdOutlineWbSunny className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Panneaux solaires</span>
                        </div>
                      )}

                      {/* Vidéo surveillance */}
                      {property?.options?.hasVideoSurveillance && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdOutlineVisibility className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Vidéo surveillance</span>
                        </div>
                      )}

                      {/* Portail électrique */}
                      {property?.options?.hasElectricGate && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdOutlineDoorFront className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Portail électrique</span>
                        </div>
                      )}

                      {/* Domotique intelligente */}
                      {property?.options?.hasSmartHome && (
                        <div
                          className="rounded-lg  p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdOutlineSmartToy className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement} >Domotique intelligente</span>
                        </div>
                      )}
                    </div>
                  )
                }
              </div>
            </Col>


            <Col md={12} >
              <div className="row">
                <div className="col-md-12">
                  <div className="" style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                    <div></div>
                    <div className="" style={{ width: "100%", display: "flex", justifyContent: "end", paddingRight: "100px" }}>
                      <div>
                        <button
                          type="button" variant="white"
                          className="btn btn-white text-dark rounded-lg mx-2" style={{ padding: "10px 20px 10px 20px", fontSize: "30px", borderRadius: "100px" }}
                          onClick={() => {
                            dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: {} });
                            dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: property });
                            navigate(`/${ROUTES.RESERVATION_FORM_PAGE_WEB}`, { state: property });
                          }}
                        >
                          Réserver
                        </button>
                      </div>
                      <div>
                        <button
                          type="button" variant="white"
                          className="btn btn-white rounded-lg mx-2" style={{ padding: "10px 20px 10px 20px", fontSize: "30px", borderRadius: "100px" }}
                          onClick={handleShowModalShare}
                        >
                          <MdShare className="text-dark" size={40} />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>

          </div>
        </div>

        <div style={{ position: "absolute", right: "1%", bottom: -30, zIndex: 60 }}>
          <img src={Vector_Design} />
        </div>
      </div>


      {/* Modal avec la carte */}
      <MapContainerModal
        show={showModal}
        onHide={handleCloseModal}
        address={property.address}
        lat={property.lat}
        lng={property.lng}
      />
      {/*Modal share */}
      <ShareComponentModal show={showModalShare} onHide={handleCloseModalShare} shareUrl={shareUrl} />

    </section>
  );
};

export default PropertyDetails;
